import React from 'react'
import {
  IconAchievementFeeling,
  IconDeskGlobe,
  IconFlagBearer,
  IconGrowingPlant,
  IconHandshake,
  IconMountainSummit,
  IconNotebookWriting,
  IconPaintPalette,
  IconPeopleAndCulture,
  IconPeopleConversing,
  IconPersonRunning,
} from '../Icons'
import type { IconProps } from '../Icon/types'

const FALLBACK_ICON = IconDeskGlobe

const SKILL_ICONS = {
  communication: IconPeopleConversing,
  creativity: IconPaintPalette,
  'diversity-equity-inclusion': IconNotebookWriting,
  leadership: IconFlagBearer,
  productivity: IconMountainSummit,
  strategy: IconPersonRunning,
  teamwork: IconHandshake,
  wellbeing: IconAchievementFeeling,
  'personal-growth': IconGrowingPlant,
  'people-culture': IconPeopleAndCulture,
} as const

type Slug = keyof typeof SKILL_ICONS

export const isSkillSlug = (slug: string): slug is Slug => slug in SKILL_ICONS

type SkillIconProps = { slug: string } & Omit<IconProps, 'kind'>
/**
 * Returns the standard icon given a Skill slug.
 *
 * These icons are most likely going to be located beside/near the respective Skill name,
 * in which case the `srText` prop should be left empty as the Skill name will be read by a screen reader.
 */
export const SkillIcon = ({ slug, ...props }: SkillIconProps) => {
  const Icon = isSkillSlug(slug) ? SKILL_ICONS[slug] : FALLBACK_ICON

  return <Icon srText='' {...props} />
}
